import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||1920}
    height={undefined}
    style={{aspectRatio: 1920/630}}
    viewBox="0 0 1920 630"
    fill="none"
    {...props}
  >
    <path
      fill="#43D8BE"
      fillOpacity={0.65}
      d="M1920 0H0v629.5h1920V0Z"
      opacity={0.5}
    />
    <path
      stroke="#fff"
      strokeDasharray="14.08 14.08"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M32.13 373.74 31.08 24.52h311.81M32.14 418.48v184.15"
    />
    <path
      fill="#fff"
      d="M372.17 20.57 368.31 11l-3.87 9.57-9.56 3.86 9.56 3.86 3.87 9.57 3.86-9.57 9.56-3.86-9.56-3.86Z"
    />
    <path
      stroke="#fff"
      strokeDasharray="14.08 14.08"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="m1052.55 601.47 835.32 1.05v-311.8"
    />
    <path
      fill="#fff"
      d="m1891.82 261.44 9.57 3.86-9.57 3.86-3.86 9.57-3.86-9.57-9.57-3.86 9.57-3.86 3.86-9.57 3.86 9.57Z"
    />
    <path
      stroke="#fff"
      strokeDasharray="14.08 14.08"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M391.79 24.52h1487.08M43.39 601.37h966.46M1888 236V25"
    />
    <path
      fill="#fff"
      d="m1033.89 597.85 9.57 3.86-9.57 3.86-3.86 9.57-3.86-9.57-9.56-3.86 9.56-3.86 3.86-9.57 3.86 9.57ZM36.29 390.59l9.57 3.86-9.57 3.86-3.86 9.56-3.86-9.56-9.57-3.86 9.57-3.86 3.86-9.57 3.86 9.57Z"
    />
  </svg>
)
export default SvgComponent
